"use strict";
angular.module("eventAnalysisRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.
    state("front.plan.eventanalysis.eventanalysismain", { //事件分析主页
        url: '/eventanalysismain',
        views: {
            "main@front.plan.eventanalysis": {
                templateUrl: "./planningCenter/eventAnalysis/eventAnalysisMain/main_tpl.html",
                controller:"eventAnalysisMainCtrl"
            }
        }
    })
        .
    state("front.plan.eventanalysis.eventanalysisdetail", { //事件详情页
        url: '/eventanalysisdetail?id',
        views: {
            "main@front.plan.eventanalysis": {
                templateUrl: "./planningCenter/eventAnalysis/eventAnalysisDetail/main_tpl.html",
                controller:"eventAnalysisDetailCtrl"
            }
        }
    }).
    state("front.plan.eventanalysis.newlist", { //新闻列表页
            url: '/newlist?id&keyword&field',
            views: {
                "main@front.plan.eventanalysis": {
                    templateUrl: "./planningCenter/eventAnalysis/newList/main_tpl.html",
                    controller:"newListCtrl"
                }
            }
        })
}]);